export default {"src":"/_next/static/media/condia.ef4cf0ce.svg","height":23,"width":126,"blurWidth":0,"blurHeight":0};